import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsNationalgridComponent } from './simple-icons-nationalgrid.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsNationalgridComponent ],
    exports:      [ SimpleIconsNationalgridComponent ],
    bootstrap:    []
})
export class SimpleIconsNationalgridModule {}
